import React from "react";
import { CreateTicketFormProps } from "./typing";

const formatLabel = (code: string): string =>
    code ? code.replace(/_/g, " ")?.toUpperCase() : "";

const formatDate = (): string => {
    const d = new Date();
    const day = d.getDate();
    const ord =
        day % 10 === 1 && day !== 11 ? "st" :
            day % 10 === 2 && day !== 12 ? "nd" :
                day % 10 === 3 && day !== 13 ? "rd" : "th";
    const month = d.toLocaleString('en-US', { month: 'long' });
    const time = d.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    return `${day}${ord} ${month}, ${time}`;
};

const TicketForm: React.FC<CreateTicketFormProps> = (props) => {
    const {
        ticketConfirm,
        ticketComment,
        setTicketComment,
        ticketFormOpen,
        setTicketFormOpen,
        handleTicketConfirm,
        ticketCreating,
        ticketError,
        currentOnboardingStep = '',
        handleTicketCancel,
    } = props;
    if (!ticketFormOpen) return null;
    return (

        <div className="chat-ticket-form">
            {/* Header with back arrow */}
            <div className="chat-ticket-form-header" onClick={() => {
                handleTicketCancel();
                setTicketFormOpen(false);
            }}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#5F5F5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15.833 10H4.167M9.167 15L4.167 10l5-5" />
                </svg>
                <span>Raise a ticket</span>
            </div>

            <div className="chat-ticket-form-body">
                <div className="chat-ticket-form-field">
                    <label className="chat-ticket-form-label">Category:</label>
                    <div className="chat-ticket-form-value">{formatLabel(ticketConfirm?.category || 'Other')}</div>
                </div>
                <div className="chat-ticket-form-field">
                    <label className="chat-ticket-form-label">Step:</label>
                    <div className="chat-ticket-form-value">{formatLabel(currentOnboardingStep) || '—'}</div>
                </div>
                <div className="chat-ticket-form-field">
                    <label className="chat-ticket-form-label">Description:</label>
                    <div className="chat-ticket-form-value" title={ticketConfirm?.description}>{ticketConfirm?.description?.substring(0, 90)+ (ticketConfirm?.description && ticketConfirm?.description.length > 90 ? '...' : '') || ''}</div>
                </div>
                <div className="chat-ticket-form-field">
                    <label className="chat-ticket-form-label">Timestamp:</label>
                    <div className="chat-ticket-form-value">{formatDate()}</div>
                </div>
                <div className="chat-ticket-form-field-comment">
                    <label className="chat-ticket-form-label-comment">Comments (Optional)</label>
                    <div className="ticket-detail-comment-item">
                        <textarea
                            className="chat-ticket-form-textarea"
                            placeholder="Enter additional comments here..."
                            value={ticketComment}
                            onChange={(e) => setTicketComment(e.target.value)}
                            rows={3}
                        />
                    </div>
                </div>
            </div>
            <div className="chat-ticket-form-footer">
                <button
                    className="chat-ticket-form-submit"
                    onClick={handleTicketConfirm}
                    disabled={ticketCreating}
                >
                    {ticketCreating ? 'Raising Ticket...' : 'Raise ticket'}
                </button>
                {ticketError && (
                    <div className="chat-ticket-error">{ticketError}</div>
                )}
            </div>
        </div>

    );
};

export default TicketForm;
